@if (!showConfirmDialog()) {
<app-modal titleId="new-charge-title" (closeBlank)="onCloseClick()">
  <!-- HEADER con banda gris -->
  <header class="nc-header grid grid-cols-[1fr_auto] py-6 px-6">
    <section>
      <span class="text-neutral-600 text-2xl font-['Inter'] leading-normal">
        Nuevo cobro
      </span>
      <span class="block text-neutral-600 text-xs font-['Inter'] leading-tight mt-2">
        Completa los datos para continuar con el cobro
      </span>
    </section>
    <button type="button" class="w-6 h-6" aria-label="Cerrar" (click)="onCloseClick()">
      <img class="w-6 h-6" src="../../../assets/img/ic-close.svg" />
    </button>
  </header>
  <hr class="nc-divider" />

  <section class="nc-body py-6 px-6">
    <form [formGroup]="form">
      <!-- Cabeceras de columnas -->
      <div class="grid-head">
        <span>Documento de referencia</span>
        <span>Descripción</span>
        <span>Monto</span>
      </div>

      <!-- Una línea = un documento -->
      <div class="grid gap-4" formArrayName="lines">
        @for (g of lines.controls; track $index) {
        <div class="grid-row" [formGroup]="$any(g)">
          <div class="docref">
            <!-- <select formControlName="docType" aria-label="Tipo de documento" (change)="onSelectChange($event, $index)">
                  <option value="" disabled>Selecciona</option>
                  <option [value]="chargeItemDocumentType.Factura">N° Factura</option>
                  <option [value]="chargeItemDocumentType.OC">Orden de Cobro</option>
                  <option [value]="chargeItemDocumentType.Referencia">N° Referencia</option>
                </select> -->
            <p-select formControlName="docType" [options]="docTypeOptions" optionLabel="label" optionValue="value"
              placeholder="Selecciona" [appendTo]="'body'" (onChange)="onSelectChange($event, $index)">
              <ng-template #dropdownicon>
                <img class="w-6 h-6" src="../../../assets/img/ic-dropdown.svg" />
              </ng-template>
            </p-select>
            <input type="text" formControlName="reference" placeholder="Número" (keypress)="onlyNumbers($event)" />
          </div>

          <input type="text" formControlName="description" placeholder="Ingresa una descripción" />

          <div class="amount-field">
            <input type="text" formControlName="amountCLP" placeholder="$ 0" 
                   (input)="onAmountInput($event, $index)" 
                   (keypress)="onAmountKeypress($event, $index)"
                   (paste)="onAmountPaste($event, $index)"
                   (blur)="onAmountBlur($index)" [class.error]="getAmountError($index)" />
            @if (getAmountError($index)) {
              <div class="error-message">{{ getAmountError($index) }}</div>
            }
          </div>

          @if(lines.length > 1) {
          <button type="button" class="row-remove" (click)="removeLine($index)" aria-label="Eliminar documento">
            <img class="w-6 h-6" src="../../../assets/img/charges/ic-remove-item.svg" />
          </button>
          }
        </div>
        }
      </div>

      <!-- Añadir otro (centrado) -->
      <div class="flex justify-center mt-8">
        <button type="button" class="inline-flex gap-2 font-semibold font-['Inter'] text-indigo-500"
          (click)="addLine()">
          <img class="w-6 h-6" src="../../../assets/img/charges/ic-plus-button.svg" />
          Añadir otro
        </button>
      </div>

      <!-- Total a cobrar -->
      <div
        class="grid grid-cols-[4fr_1fr] items-center gap-8 mt-4 pr-2 text-neutral-600 text-xl font-bold font-['Inter'] text-right">
        <div>
          <img class="inline cursor-pointer mr-1 w-4" src="../../../../assets/img/ic-info.svg" alt=""
            pTooltip="El monto del cobro debe tener máximo 9 dígitos" tooltipPosition="left" placeholder="Left">
          Total a cobrar
        </div>
        <span>{{ totalAmount | currencyClp }}</span>
      </div>
      @if (isTotalAmountExceeded) {
        <div class="total-error-message">
          Monto de cobro excedido
        </div>
      }
    </form>
  </section>

  <!-- FOOTER -->
  <footer class="nc-footer" modal-footer>
    <button type="button" (click)="onSaveAndClose()"
      class="button-footer text-neutral-600 border-indigo-500 border-2 hover:bg-indigo-500 hover:text-white">
      Guardar y cerrar
    </button>
    <button type="button" (click)="onConfirm()" [disabled]="!isFormValid"
      class="button-footer bg-indigo-500 text-white hover:bg-indigo-600 disabled:bg-neutral-400 ">
      Continuar
    </button>
  </footer>
</app-modal>
}

@if (showConfirmDialog()) {
<app-confirm-charge-dialog [items]="getFormData()" [total]="totalAmount" [paymentLinkUrl]="paymentLinkUrl"
  (close)="closeConfirmDialog()" (confirmed)="onChargeConfirmed()">
</app-confirm-charge-dialog>
}

@if (showUnsavedChangesDialog()) {
<app-unsaved-changes-dialog (close)="onUnsavedChangesClose()" (saveAndClose)="onUnsavedChangesSaveAndClose()">
</app-unsaved-changes-dialog>
}